//tabs mobile
const tabsCurrent = $('.tabs__current');
const tabsList = $('.tabs__list');

$(tabsCurrent).click(function() {
  $(this).toggleClass('js-open');
  $(tabsList).toggleClass('js-open');
});